module.exports = __webpack_public_path__ + "static/media/Commercial-e-Marketing.d2c11ab0.png";